import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../../context/AuthProvider'; // Import the AuthContext
import { Link, useNavigate } from 'react-router-dom';

import './login.css';
import BannerImage from "../../assets/Space-4.jpg";
import Logo from "../../assets/Alien-Blank.png";

function Login() {
  const { login } = useContext(AuthContext); // Get the login method from the context
  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [statusMsg, setStatusMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        navigate('/dashboard/'); // Go back to the previous page
      }, 1000); // Redirect after 1 second
    }
  }, [success, navigate]);

  const handleLogin = async () => {
    if (isSubmitting) {
      return;
    }

    setErrMsg('');
    if (!user.trim() || !pwd) {
      setErrMsg('Enter both username and password.');
      return;
    }

    setIsSubmitting(true);
    setStatusMsg('Checking your login...');
    const result = await login(user, pwd); // Use the login method from context
    if (result?.success) {
      setStatusMsg('Login successful. Sending you to the dashboard...');
      setSuccess(true);
    } else {
      setStatusMsg('');
      setErrMsg(result?.message || 'Unable to log in right now.');
    }
    setIsSubmitting(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleLogin();
  };

  return (
    <>
      {success ? (
        <div>
          <h1>You are logged in!</h1>
          <br />
          <div className='login-logo'>
            <Link to="/"><img src={Logo} alt="Alien Trader" /></Link>
            <div><h1 className='white'>Alien Trader Co</h1></div>
          </div>
        </div>
      ) : (
        <div className='login'>
          <div className='rightside' style={{ backgroundImage: `url(${BannerImage})` }}>
            <div className='login-logo'>
              <Link to="/"><img src={Logo} alt="Alien Trader" /></Link>
              <div><h1 className='white'>Alien Trader Co</h1></div>
            </div>
            <div className='login-box shadow-sm'>
              <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
              <p className="statusmsg" aria-live="polite">{statusMsg || '\u00A0'}</p>
              <h2>Please Login</h2>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder='Username'
                  id="username"
                  autoComplete="off"
                  onChange={(e) => setUser(e.target.value)}
                  value={user}
                />
                <input
                  type="password" // Change input type to 'password'
                  placeholder='Password'
                  id="password"
                  onChange={(e) => setPwd(e.target.value)}
                  value={pwd}
                />
                <span>Don't have an account? <Link to="/register">Register</Link></span>
                <button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Logging in...' : 'Login'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
